import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Div } from 'components/Ui';
import { showDrawer as showDrawerRequest } from 'containers/DrawerManager/actions';
import classnames from 'classnames';
import commonStyles from 'containers/PrimoProfile/styles.scss';
import { getBillingAccount as getBillingAccountRequest } from 'containers/PrimoProfile/actions';
import { selectSelectedServiceLocationId } from 'containers/PrimoAccount/selectors';
import MessageDialog from 'components/Dialogs/MessageDialog';
import PasswordResetEmailSentDialog from 'components/Dialogs/PasswordResetEmailSentDialog/Loadable';
import {
  selectBillingAccount,
  selectBillingAccounts,
  selectUserInfo,
} from 'containers/PrimoProfile/selectors';
import auth0 from 'auth0-js';
import { getAuthClientId } from 'utils/domainHelper';
import { ORACLE_REALM_NAME } from 'containers/Authentication/constants';
import { GTM_TRACKING_TAGS } from 'utils/constants';
import { getServerData } from 'utils/getServerData';
import styles from './styles.scss';
import Block from '../Block';
import EditAccountNameDrawer from './EditAccountNameDrawer';
// import EditPasswordDrawer from './EditPasswordDrawer';
import EditEmailAddressDrawer from './EditEmailAddressDrawer';
import AddNewAccountLoginDrawer from './AddNewAccountLoginDrawer';
import {
  // EDIT_PASSWORD,
  EDIT_ACCOUNT_NAME,
  EDIT_EMAIL_ADDRESS,
} from './constants';
function AccountDetails(props) {
  const {
    userInfo,
    serviceLocationId,
    getBillingAccount,
    billingAccount,
    billingAccounts,
    showDrawer,
  } = props;

  useEffect(() => {
    if (serviceLocationId) {
      getBillingAccount();
    }
  }, [serviceLocationId]);

  const [showPasswordResetDialog, changeShowPasswordResetDialog] = useState(
    false,
  );
  const [showPasswordErrorDialog, changeShowPasswordErrorDialog] = useState(
    false,
  );

  const handleChangePassword = () => {
    const webAuth = new auth0.WebAuth({
      domain: getServerData('AUTH_DOMAIN'),
      clientID: getAuthClientId(),
    });

    webAuth.changePassword(
      {
        connection: ORACLE_REALM_NAME,
        email: userInfo.email,
      },
      (err) => {
        if (err) {
          changeShowPasswordErrorDialog(true);
        } else {
          changeShowPasswordResetDialog(true);
        }
      },
    );
  };

  const handleClosePasswordResetDialog = () => {
    changeShowPasswordResetDialog(false);
  };

  const handleClosePasswordErrorDialog = () => {
    changeShowPasswordErrorDialog(false);
  };

  return (
    <Fragment>
      <Block title="Account details">
        <Fragment>
          <div
            className={commonStyles.section}
            data-tracking={GTM_TRACKING_TAGS['Account details']}
          >
            <div className={commonStyles.subBlock}>
              <Div className={commonStyles.subTitle}>Name</Div>
              <div>
                <div>
                  {userInfo.firstName} {userInfo.lastName}
                </div>
                <div>
                  <Button
                    className={styles.linkButton}
                    text="Edit"
                    onClick={() => showDrawer(EDIT_ACCOUNT_NAME)}
                    link
                    bold
                  />
                </div>
              </div>
            </div>
            <div className={commonStyles.subBlock}>
              <Div className={commonStyles.subTitle}>Password</Div>
              <div>********</div>
              {
                <div>
                  <Button
                    className={styles.linkButton}
                    text="Reset password"
                    onClick={handleChangePassword}
                    link
                    bold
                  />
                </div>
              }
            </div>
          </div>
          <div className={commonStyles.section}>
            <div className={commonStyles.subBlock}>
              <Div className={commonStyles.subTitle}>Account Number</Div>
              <div>
                <div>
                  {billingAccount.accountNumber}
                  {billingAccount.id}
                </div>
              </div>
            </div>
            {/* <div
              className={classnames(
                commonStyles.subBlock,
                styles.subBlockOverRide,
              )}
            >
              <Div className={commonStyles.subTitle}>Other Usernames</Div>
              {billingAccounts.map((account) => (
                <div className={styles.userNameText} key={account.userName}>
                  {account.userName}
                </div>
              ))}
              <div>
                <Button
                  className={styles.linkButton}
                  text="Manage Users"
                  onClick={() => showDrawer(EDIT_EMAIL_ADDRESS)}
                  link
                  bold
                />
              </div>
            </div> */}
          </div>
          <div className={commonStyles.section}>
            <div className={commonStyles.subBlock}>
              <Div className={commonStyles.subTitle}>User Name / Email</Div>
              <div>
                <div>{userInfo.email ? userInfo.email.toUpperCase() : ''}</div>
              </div>
            </div>
          </div>
        </Fragment>
      </Block>
      <EditAccountNameDrawer />
      <EditEmailAddressDrawer />
      {/* <EditPasswordDrawer /> */}
      <AddNewAccountLoginDrawer />
      <PasswordResetEmailSentDialog
        open={showPasswordResetDialog}
        onClose={handleClosePasswordResetDialog}
        email={userInfo.email}
      />
      {showPasswordErrorDialog && (
        <MessageDialog
          open={showPasswordErrorDialog}
          onClose={handleClosePasswordErrorDialog}
          message={
            "We're sorry you're experiencing an error. Please contact us at 800-261-7524 for immediate assistance. Thank you!"
          }
          isErrorMessage
        />
      )}
    </Fragment>
  );
}

AccountDetails.propTypes = {
  userInfo: PropTypes.object,
  serviceLocationId: PropTypes.string,
  getBillingAccount: PropTypes.func,
  billingAccount: PropTypes.object,
  showDrawer: PropTypes.func,
};

AccountDetails.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  userInfo: selectUserInfo(),
  serviceLocationId: selectSelectedServiceLocationId(),
  billingAccount: selectBillingAccount(),
  billingAccounts: selectBillingAccounts(),
});

const mapDispatchToProps = {
  showDrawer: showDrawerRequest,
  getBillingAccount: getBillingAccountRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails);
